import { motion } from "framer-motion";
import { Breadcrumbs } from "./Breadcrumbs";

export const PageHeader = ({ crumbs, badge, title, intro, id = "page-heading" }) => (
  <section className="relative pt-12 pb-10" aria-labelledby={id}>
    <div className="absolute inset-0 dot-grid opacity-30 pointer-events-none" aria-hidden="true" />
    <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="relative max-w-7xl mx-auto safe-x sm:px-8">
      <Breadcrumbs items={crumbs} />
      {badge && <span className="badge-pill mb-5">{badge}</span>}
      <h1 id={id} className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[1.05] break-words">{title}</h1>
      {intro && <p className="mt-5 text-slate-400 text-base sm:text-lg max-w-2xl leading-relaxed">{intro}</p>}
    </motion.div>
  </section>
);
